import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-004d2ef2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-note py-1 fw-bold px-2" }


export default /*#__PURE__*/_defineComponent({
  props: {
  content: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.content), 1))
}
}

})